import React from 'react';
import { characterImageUrl } from '../../constants/projectCharacters';

/**
 * صورة شخصية من مجلد public — مناسبة للهيدر، السايدبار، البطاقات.
 * knockoutDarkBackground: يُخفّي الخلفية السوداء في PNG (دمج screen مع خلفية الصفحة).
 * @param {{ imageFile: string, alt: string, className?: string, knockoutDarkBackground?: boolean }} props
 */
const StudentCharacterImg = ({ imageFile, alt, className = '', knockoutDarkBackground = false }) => (
  <img
    src={characterImageUrl(imageFile)}
    alt={alt}
    className={`object-contain select-none pointer-events-none ${
      knockoutDarkBackground ? 'mix-blend-screen' : ''
    } ${className}`.trim()}
    loading="lazy"
    decoding="async"
  />
);

export default StudentCharacterImg;
